var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.295 11.977a.877.877 0 0 1 .15-.491.99.99 0 0 1 .85-.502H28.79L30 4H13.166C8.736 4 4.56 7.662 3.86 12.16c-.412 2.644.467 4.997 2.16 6.49.223.197.462.371.712.53.908.565 1.976.62 3.042.62H19.79c.043.015.074.029.115.044.056.017.106.041.155.065.04.02.08.038.114.057.04.03.073.057.107.09.054.04.102.088.144.14l.015.025a.97.97 0 0 1 .121.22c.004.012.01.017.012.026a.885.885 0 0 1-.072.847.985.985 0 0 1-.851.5H3.099L2 28.766h16.698c4.405 0 8.554-3.636 9.253-8.108.41-2.629-.462-4.97-2.146-6.449a5.677 5.677 0 0 0-1.027-.722c-.87-.477-1.863-.483-2.853-.483l-.527-.007h-9.1a.996.996 0 0 1-.927-.666.928.928 0 0 1-.074-.334l-.001-.01v-.01z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsx);
export default __webpack_public_path__ + "static/media/SSX.92670141d85eb2d0df571dfa6948a13e.svg";
export { ForwardRef as ReactComponent };